import { apiUrl } from "../runtime.js";

let accessToken: string | null = null;

export function setAccessToken(token: string): void {
  accessToken = token;
}

export class ApiError extends Error {
  constructor(public status: number, public retryAfter?: number) {
    super(`API ${status}`);
  }
}

export async function apiFetch<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers);
  if (accessToken) headers.set("Authorization", `Bearer ${accessToken}`);
  const res = await fetch(apiUrl(path), { ...init, headers });
  if (!res.ok) {
    const retryAfter = Number(res.headers.get("retry-after")) || undefined;
    throw new ApiError(res.status, retryAfter);
  }
  return (await res.json()) as T;
}
